import a from "react";
import { useKioskLanding as t } from "../../context.js";
import s from "./kioskHeaderImg.module.scss.js";
function o() {
  const { configuration: e } = t(), r = e == null ? void 0 : e.service.design.images.header;
  return r ? /* @__PURE__ */ a.createElement(
    "img",
    {
      "data-testid": "kiosk-header-img",
      className: s.headerImage,
      src: r,
      alt: "header"
    }
  ) : null;
}
export {
  o as KioskHeaderImg
};
//# sourceMappingURL=KioskHeaderImg.js.map
